<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('mkv-to-wav-converter', 'MKV → WAV');

function handleBatchCreated(batchId: string) {
  console.log('[MKV-to-WAV Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[MKV-to-WAV Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[MKV-to-WAV Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[MKV-to-WAV Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[MKV-to-WAV Converter] Credits updated:', credits);
}
</script>
